// Public Terms of Use + wellness disclaimer. No auth, no chrome — reviewer-friendly.

const SECTIONS = [
  {
    h: "What UnAnonymous is",
    body: [
      "UnAnonymous is a private, self-guided wellness companion. It offers short guided exercises, reflection tools, and supportive resources for difficult moments.",
      "It is not a medical device, a mental-health treatment, a diagnostic tool, therapy, or a substitute for professional care. Nothing in the app — including the reflective companion — is medical or psychiatric advice.",
    ],
  },
  {
    h: "Emergencies",
    body: [
      "UnAnonymous does not provide emergency services. If you are in immediate danger, or someone else is, contact your local emergency number right away. The Safe Reach page lists independent crisis resources, but reaching them is always your action, on your device.",
    ],
  },
  {
    h: "Your content",
    body: [
      "Your reflections, journal entries, letters, drafts, Mosaic items, and toolkit are designed to remain device-first. An optional account may store identity and minimal account state, but it does not automatically upload that private content. Use the Backup page to keep your own copies.",
    ],
  },
  {
    h: "Optional accounts",
    body: [
      "You may use core UnAnonymous reflection features without an account. If you create an account, authentication is provided through Supabase and may use email or an enabled social sign-in provider.",
      "You are responsible for access to your sign-in email or provider account. Deleting the UnAnonymous account removes the account identity and minimal server profile; device-local content is managed separately on your device.",
    ],
  },
  {
    h: "Premium subscription",
    body: [
      "UnAnonymous Premium is optional and purchased through Google Play. Available purchase options are the options shown in the app and Google Play at the time of purchase. Premium unlocks the full reset library, unlimited Toolkit, and more ways to reflect.",
      "Prices and renewal terms are shown before purchase. Recurring subscriptions renew unless canceled according to Google Play terms and can be managed in Google Play → Subscriptions. Any one-time option, if offered, does not renew. Crisis support and essential Immediate Reset options are never behind Premium.",
    ],
  },
  {
    h: "Acceptable use",
    body: [
      "Use the app for personal, non-commercial wellbeing. Don't attempt to reverse-engineer, resell, or misuse the service.",
    ],
  },
  {
    h: "No warranty",
    body: [
      "The app is provided \"as is\". We work hard to keep it dependable, but we can't guarantee it will always be available or error-free, and we aren't liable for decisions made based on its content.",
    ],
  },
  {
    h: "Changes",
    body: [
      "We may update these terms as the product evolves. Material changes will be reflected on this page with an updated date.",
    ],
  },
  {
    h: "Contact",
    body: ["Questions? Reach us at rezzocandice@gmail.com."],
  },
];

export default function Terms() {
  return (
    <div
      data-testid="terms-page"
      className="min-h-screen"
      style={{ background: "var(--un-bg-1)" }}
    >
      <div className="max-w-[680px] mx-auto px-6 py-14">
        <h1
          className="text-[34px]"
          style={{ color: "var(--un-text-1)", fontFamily: "'Lora', serif", fontWeight: 500 }}
        >
          Terms of Use
        </h1>
        <p
          className="mt-1 italic text-[15px]"
          style={{ color: "var(--un-text-3)", fontFamily: "'Cormorant Garamond', serif", fontSize: "17px" }}
        >
          Last updated September 23, 2026
        </p>

        {SECTIONS.map((s) => (
          <section key={s.h} className="mt-9">
            <h2
              className="text-[15px] font-semibold mb-2.5"
              style={{ color: "var(--un-text-1)", fontFamily: "Manrope, sans-serif" }}
            >
              {s.h}
            </h2>
            {s.body.map((p, i) => (
              <p
                key={i}
                className="text-[15px] leading-[1.7] mb-3"
                style={{ color: "var(--un-text-2)", fontFamily: "Manrope, sans-serif" }}
              >
                {p}
              </p>
            ))}
          </section>
        ))}

        <a
          href="/"
          data-testid="terms-return-link"
          className="inline-block mt-12 mb-6 text-[14px] underline underline-offset-2"
          style={{ color: "var(--un-plum)", fontFamily: "Manrope, sans-serif" }}
        >
          Return to UnAnonymous
        </a>
      </div>
    </div>
  );
}
